module.exports = __webpack_public_path__ + "img/videowiki.63ee27cb.png";